import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clickupAssignees: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-assignees',
		defaultMessage: 'Assignees',
		description: 'Name of the Assignee field in a Clickup list',
	},
	clickupCreator: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-creator',
		defaultMessage: 'Creator',
		description: 'Name of the Creator field in a Clickup list',
	},
	clickupWatchers: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-watchers',
		defaultMessage: 'Watchers',
		description: 'Name of the Watchers field in a Clickup list',
	},
	clickupName: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-name',
		defaultMessage: 'Name',
		description: 'Name of the Name field in a Clickup list',
	},
	clickupDescription: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-description',
		defaultMessage: 'Description',
		description: 'Name of the Description field in a Clickup list',
	},
	clickupDueDate: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-due-date',
		defaultMessage: 'Due date',
		description: 'Name of the due date field in a Clickup list',
	},
	clickupStartDate: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-start-date',
		defaultMessage: 'Start date',
		description: 'Name of the start date field in a Clickup list',
	},
	clickupTags: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-tags',
		defaultMessage: 'Tags',
		description: 'Name of the tags field in a Clickup list',
	},
	clickupStatus: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-status',
		defaultMessage: 'Status',
		description: 'Name of the status field in a Clickup list',
	},
	clickupPriority: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-priority',
		defaultMessage: 'Priority',
		description: 'Name of the priority field in a Clickup list',
	},
	clickupSprintPoints: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-sprint-points',
		defaultMessage: 'Points',
		description: 'Name of the sprint points field in a Clickup list',
	},
	clickupTimeSpent: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-time-spent',
		defaultMessage: 'Time spent',
		description: 'Name of the time spent field in a Clickup list',
	},
	clickupTimeEstimate: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-time-estimate',
		defaultMessage: 'Time estimate',
		description: 'Name of the time estimate field in a Clickup list',
	},
});
